import React from "react";
import { VeriDatePickerProps } from "./VeriDatePicker.types";
import { VeriDatePickerProvider } from "../VeriDatePickerContext";
import { VeriDatePickerContainer } from "../VeriDatePickerContainer";

const VeriDatePicker: React.FC<VeriDatePickerProps> = ({
  initialDate,
  ...rest
}) => {
  return (
    <VeriDatePickerProvider initialDateString={rest.value || ""} {...rest}>
      <VeriDatePickerContainer {...rest} />
    </VeriDatePickerProvider>
  );
};

export default VeriDatePicker;
